<template>
    <div v-if="config['texts'] != undefined" id="container-tv" class="h-full max-md:pt-special">
        <div id="live-TV" class="mx-special">
            <div id="live" class="relative text-center">
                <VideoPlayer type="default" @pause="false" title="Caminando con Jesús Televisión en Vivo" :link="URL_LIVE" :progress="0" :isMuted="false" :isControls="true" class="w-live-stream rounded-smoth max-md:w-full" />
            </div>
        </div>
        <div id="programming" v-if="programs.length > 0" class="mt-special mx-special">
            <div id="text-programming-tv" class="font-extrabold mb-special font-bloggerB text-content-subtitle-desktop max-md:text-content-subtitle-mobile dark:text-primary-dark-text">
                <span>
                    {{ config['texts'][0] }}
                </span>
            </div>
            <div id="live" class="grid grid-cols-6 gap-4 relative max-md:grid-cols-2">
                <ProgramCard v-for="program in programs" :data="program" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, nextTick } from 'vue';
import ProgramCard from '@/components/tv/ProgramCard.vue';
import { VideoPlayer } from 'vue-hls-video-player';
import { generalStore } from '@/stores';

const store = generalStore();
const route = store.route;

var config = ref({});
config.value['programs'] = [];
var programs = ref([]);

const URL_LIVE = import.meta.env.VITE_URL_LIVE;

store.setIsPP(false);

onBeforeMount(async () => {
    window.scrollTo(top);
    await store.getConfiguration(route.name);
    await nextTick();
    config.value = store.getSessionStorage('configuration-' + route.name);

    if (config.value['programs'].length > 0) {
        config.value['programs'].forEach(data => {
            if (data['days'].includes(store.getToday()['day']) && data['emision'].includes(store.getToday()['month'])) {
                programs.value.push(data);
            }
        });
    }
})
</script>